import {UserCredentialType} from 'data/enums'
import {APIResponse} from './APIRequestor'
import published from 'utils/published'
import services from 'services'
import firebase from 'firebase/app'
import 'firebase/auth'
import {Optional, User} from 'data/types'
import selector, {identitySelector} from 'utils/selector'
import APIService from './APIService'
import {CookieAuthTokenProvider, IAuthTokenProvider} from './AuthTokenProvider'

export default class AuthService {
  public static tokenProvider: IAuthTokenProvider = new CookieAuthTokenProvider()

  public static removeAuthToken = () => {
    AuthService.tokenProvider.removeAuthToken()
  }

  public static storeAuthToken = (jwt: string) => {
    AuthService.tokenProvider.storeAuthToken(jwt)
    services.getAuthService().isLoggedIn.publish(jwt !== '')
  }

  public static logOut = () => {
    AuthService.removeAuthToken()
    services.getAuthService().isLoggedIn.publish(false)
    services.reset()
    firebase.auth().signOut()
  }

  public static getAuthToken = () => AuthService.tokenProvider.getAuthToken()

  public constructor() {
    this.loginWithToken()
  }

  public user = published<Optional<User>>(null)
  public isLoggedIn = published<boolean>(false)
  public error = published<Optional<string>>(null)

  private loginWithToken = async (startLoading = true) => {
    const token = AuthService.getAuthToken()
    if (!token) {
      return
    }

    if (startLoading) {
      this.isLoggedIn.startLoading()
    }
    const me = await APIService.getMe()
    if (me.ok) {
      this.user.publish(me.body)
      await services.getConfigService().loadConfig()
      this.isLoggedIn.publish(true)
      this.error.publish(null)
    } else {
      this.error.publish(me.error.code)
    }
    this.isLoggedIn.endLoading()
  }

  public login = async (identifier: string, credential: string, credentialType: UserCredentialType) => {
    const response: APIResponse<{jwt: string}> = await APIService.login({identifier, credential, credentialType})
    if (response.ok) {
      AuthService.storeAuthToken(response.body.jwt)
      await this.loginWithToken(false)
    } else {
      this.error.publish(response.error.code)
    }
  }
}

export const authServiceSelector = selector(identitySelector<string>(), () => new AuthService())
